import {Text} from '@esgi/ui/typography';

export function PageTitle() {
	return (
		<Text size='large' color='base'>
			Dashboard
		</Text>
	);
}
